<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">نبض من أثير</h1>
<ol class="toc">
<li id="toc-li-2"><a href="#/text/ch002#بولا-بولس-ربيز-شاعرة-الياسمين"><span dir="rtl">بولا بولس ربيز (شاعرة الياسمين)</span></a></li>
<li id="toc-li-3"><a href="#/text/ch003#الإهداء"><span dir="rtl">الإهداء</span></a></li>
<li id="toc-li-4"><a href="#/text/ch004#حقوق-النشر"><span dir="rtl">حقوق النشر</span>©</a></li>
<li id="toc-li-5"><a href="#/text/ch005#شكر-وتقدير"><span dir="rtl">شكر وتقدير</span></a></li>
<li id="toc-li-6"><span href="#/text/ch006#مقدمة" title="Link target outside of Sample"><span dir="rtl">مقدِّمة</span></span></li>
<li id="toc-li-7"><span href="#/text/ch007#عن-كتاب-نبض-من-أثير" title="Link target outside of Sample"><span dir="rtl">عن كتاب نبض من أثير</span></span></li>
<li id="toc-li-8"><span href="#/text/ch008#نبض-من-أثير" title="Link target outside of Sample"><span dir="rtl">نبضٌ مِن أثيرٍ</span></span></li>
<li id="toc-li-9"><span href="#/text/ch009#حلم-الأجنحة" title="Link target outside of Sample"><span dir="rtl">حلمُ الأجنحة</span></span></li>
<li id="toc-li-10"><span href="#/text/ch010#الشمس-والقمر" title="Link target outside of Sample"><span dir="rtl">الشَّمس والقمر</span></span></li>
<li id="toc-li-11"><span href="#/text/ch011#غرباء-من-نسج-الوهم" title="Link target outside of Sample"><span dir="rtl">غرباء مِن نسْج الوهم</span></span></li>
<li id="toc-li-12"><span href="#/text/ch012#لو-أحببتني" title="Link target outside of Sample"><span dir="rtl">لو أحببتَني</span></span></li>
<li id="toc-li-13"><span href="#/text/ch013#في-قصتنا-حوار" title="Link target outside of Sample"><span dir="rtl">في قصَّتنا حوار</span></span></li>
<li id="toc-li-14"><span href="#/text/ch014#تائه-في-امرأة-من-نسج-الخيال" title="Link target outside of Sample"><span dir="rtl">تائهٌ في امرأةٍ مِن نسْج الخيال</span></span></li>
<li id="toc-li-15"><span href="#/text/ch015#سجل-الآن" title="Link target outside of Sample"><span dir="rtl">سَجِّلِ الآنَ</span></span></li>
<li id="toc-li-16"><span href="#/text/ch016#آماريس" title="Link target outside of Sample"><span dir="rtl">آماريس</span></span></li>
<li id="toc-li-17"><span href="#/text/ch017#أرابيسك" title="Link target outside of Sample"><span dir="rtl">أرابِيسك</span></span></li>
<li id="toc-li-18"><span href="#/text/ch018#الكوكب-يعشق-نجمة-أحيانا" title="Link target outside of Sample"><span dir="rtl">الكوكب يعشق نجمةً أحيانًا</span></span></li>
<li id="toc-li-19"><span href="#/text/ch019#عن-معنى-الاختيار" title="Link target outside of Sample"><span dir="rtl">عن معنى الاختيار</span></span></li>
<li id="toc-li-20"><span href="#/text/ch020#أعتذر-إليك" title="Link target outside of Sample"><span dir="rtl">أعتذر إليك</span></span></li>
<li id="toc-li-21"><span href="#/text/ch021#السيرك-وقارئة-الحظ" title="Link target outside of Sample"><span dir="rtl">السيرك وقارئة الحظِّ</span></span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?3802ba99